var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { isCallActive: this.call && _vm.chatWindowStatus == 3 },
      attrs: { id: "chatWindow" },
    },
    [
      _c(
        "div",
        { staticClass: "container", on: { dragover: _vm.dragover } },
        [
          _vm.isLoading
            ? _c("loading-animation", { attrs: { shown: _vm.isLoading } })
            : _vm._e(),
          _c("Header", {
            attrs: {
              currentType: _vm.currentType.text,
              chatWindowStatus: _vm.chatWindowStatus,
            },
            on: { closeChat: _vm.closeChat },
          }),
          _c(
            "div",
            { ref: "content", class: { content: true } },
            [
              this.dragActive && _vm.threadState === "open"
                ? _c("DropFile", {
                    attrs: { dragActive: _vm.dragActive },
                    on: { dragActive: _vm.toggleDrag },
                  })
                : _c(_vm.componentMap[_vm.chatWindowStatus].component, {
                    tag: "component",
                    on: { closeChat: _vm.closeChat },
                  }),
              _vm.agent.isTyping
                ? _c("div", { staticClass: "typingAnimation" })
                : _vm._e(),
            ],
            1
          ),
          _vm.chatWindowStatus == 3 ? _c("ChatFooter") : _vm._e(),
        ],
        1
      ),
      _c("vue-confirm-dialog", { attrs: { id: "ChatVueDialog" } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }